import {HttpGet,getData,postData,downDataNew} from '@/assets/js/api.js'
//获得国家
export const GetCountryList = (params,fn) => {
	let methods = '/api/Project/GetCountryList';

	return getData(methods, params, 1, fn);
};

//获取项目中使用过的国家列表
export const GetCountryListInProject = (params,fn) => {
	let methods = '/api/Project/GetCountryListInProject';
	return getData(methods, params, 1, fn);
};

//获得时区
export const GetTimeZoneList = (params,fn) => {
	let methods = '/api/Project/GetTimeZoneList';
	getData(methods, params, 1, fn);
};

//获得项目类型
export const GetProjectTypeList = fn => {
	let methods = '/api/Project/GetProjectTypeList';
	getData(methods, {}, 1, fn);
};

//创建项目
export const AddProject = (params,fn) => {
	let methods = '/api/Project/Post';
	return postData(methods, params, 1, fn);
};

//获取项目列表
export const GetList = (params,fn) => {
	let methods = '/api/Project/GetList';
	return getData(methods, params, 1, fn);
};

//获取一期项目列表（同步）
export const GetTheFirstProjectList = (params,fn) => {
	let methods = '/api/Project/GetTheFirstProjectList';
	getData(methods, params, 1, fn);
};

//被邀请的项目回复
export const InviteeProjectReply = (params,fn) => {
	let methods = '/api/Project/InviteeProjectReply';
	getData(methods, params, 1, fn);
};

//删除项目
export const Delete = (params,fn) => {
	let methods = '/api/Project/Delete';
	getData(methods, params, 1, fn);
};

//更新项目存档状态
export const UpdateProjectArchiveStatus = (params,fn) => {
	let methods = '/api/Project/UpdateProjectArchiveStatus';
	getData(methods, params, 1, fn);
};

//获得项目详情
export const Get = (params,fn) => {
	let methods = '/api/Project/Get';
	return getData(methods, params, 1, fn);
};

// 获取项目详情
export const GetProjectInfo = (params,fn) => {
	let methods = '/api/project/get';
	return getData(methods, params, 1, fn);
};

//修改项目信息
export const Put = (params,fn) => {
	let methods = '/api/Project/Put';
	return postData(methods, params, 1, fn);
};

// 设置项目别名
export const UpdateProjectAlias = (params,fn) => {
	let methods = '/api/project/UpdateProjectAlias';
	return postData(methods, params, 1, fn);
};



//批量移交指定登陆者所属项目
// userType 用户ID类型(2:手机号;8:Email地址
export const TransferProject = (params,fn) => {
	let methods = '/api/Project/TransferProject';
	getData(methods, params, 1, fn);
};

//批量删除指定登陆者所属项目
export const DeleteList = (params,fn) => {
	let methods = '/api/Project/DeleteList';
	getData(methods, params, 1, fn);
};

//导出Modbus对接文件
export const ExprotModbusData = (params, that, info) => {
	let methods = '/api/StatisticalAnalysis/ExprotPointTable';
	downDataNew(methods, params, that, info, "?projectCode="+params.projectCode);
};
//导出项目数据
export const ExportDeviceList = (params, fn) => {
  const methods = "/businessapi/Analysis/ExportDeviceList";
  getData(methods, params, 1, fn);
};
//设置项目用户是否可用
export const UpdateProjectUserEnableState = (params,fn) => {
	let methods = '/api/Project/UpdateProjectUserEnableState';
	getData(methods, params, 1, fn);
};

//更新项目的坐标信息
export const UpdatePos = (params,fn) => {
	let methods = '/api/Project/UpdatePos';
	postData(methods, params, 1, fn);
};

//更新项目的坐标信息
export const GetProjectName = (params,fn) => {
	let methods = '/api/Project/GetProjectName';
	getData(methods, params, 1, fn);
};

// 谷歌地图获取地点
export const getGooleAddress = (params,fn) => {
	let methods = 'https://maps.google.com/maps/api/geocode/json';
	HttpGet(methods, params, fn);
};


// 上传消防文件到云
export const UploadFireDesignZip = (params,fn) => {
	let methods = '/api/Upload/File';
	postData(methods, params, 3,fn);
};

//上传消防文件
export const UploadFireDesignUrl = (params,fn) => {
	let methods = '/businessapi/Design/UploadFireDesignZip';
	postData(methods, params, 1,fn);
};


//下载消防json文件
export const DownloadFireDesignFile = (params,fn) => {
	let methods = '/businessapi/Design/DownloadFireDesignFile';
	getData(methods, params,1, fn);
};

//导出BACnet对接文件
export const ExprotBACnetData = (params, fn) => {
  const methods = "/api/StatisticalAnalysis/ExprotBACnet";
  getData(methods, params, 1, fn);
};

//获取lite项目列表
export const GetLiteProjectList = (params,fn) => {
	let methods = '/api/project/GetLiteProjects';
	postData(methods, params, 1, fn);
};

//导入节目单
export const ImportProgram = (params,fn) => {
  let methods = '/api/StatisticalAnalysis/ImportLightBoxConfig';
  postData(methods, params, 1, fn);
};

//导出节目单
export const ExportProgram = (params,fn) => {
  let methods = '/api/StatisticalAnalysis/ExprotLightBoxConfig';
  getData(methods, params, 1, fn);
}

// 收藏项目
export const CollectionProject = (params,fn) => {
  let methods = '/api/Project/Collection';
  
	return getData(methods, params, 1, fn);
}

// 收藏项目
export const UnCollection = (params,fn) => {
  let methods = '/api/Project/UnCollection';

	return getData(methods, params, 1, fn);
}

// 更新节假日
export const UpdateHolidays = (params) => {
	let methods = '/api/Project/UpdateHolidays';

	return postData(methods, params, 1);
};

// 查节假日
export const GetHolidays = (params) => {
	let methods = '/gateway/sdlroute/sdltool/designV2/holiday';
	return getData(methods, params, 1);
};


// 查询节假日
export const GetProjectHolidays = (params) => {
	let methods = '/api/Project/GetProjectHolidays';

	return postData(methods, params, 1);
};

//修改用户名和单位
export const UpdateProjectUser = (params) => {
	let methods = '/api/Project/UpdateProjectUser';
	return postData(methods, params, 1);
};
//上传分片文件接口
export const UploadChunk = (params,fn, options) => { 
	let methods = '/api/Upload/UploadChunk';
	return postData(methods, params, 3, fn, null, null, options);
};

//合并分片文件接口
export const MergeChunks = (params,fn) => { 
	let methods = '/api/Upload/MergeChunks';
	return postData(methods, params, 3, fn);
};

//查询已上传成功的文件分片索引列表接口
export const CheckUploadedChunks = (params,fn) => { 
	let methods = '/api/Upload/CheckUploadedChunks';
	return getData(methods, params, 1, fn);
};

//根据国家筛选时区
export const GetTimeZoneListByCountry = (params) => {
	let methods = '/api/common/GetCountryTimeZooList';

	return getData(methods, params, 1);
};

// 网关节目单导入
export const ImportGatewayProgramListConfig = (params,fn) => { 
	let methods = '/api/device/ImportGatewayProgramListConfig';

	return postData(methods, params, 1, fn);
};

// 网关节目单导出
export const ExportGatewayProgramListConfig = (params, fn) => { 
	let methods = '/api/device/ExportGatewayProgramListConfig';

	return getData(methods, params, 1, fn);
};

// 删除网关节目单
export const DeleteGatewayProgramListConfig = (params, fn) => { 
	let methods = `/api/device/DeleteGatewayProgramListConfig`;

	return getData(methods, params, 1, fn);
};
// 获取项目每日日出日落本地时间
export const GetProjectSunriseSunsetTime = (params, fn) => {
	const methods = '/api/project/GetProjectSunriseSunsetTime';

	return getData(methods, params || {}, 1, fn);
};
